module.exports = __webpack_public_path__ + "img/069.2f0404fc.png";